<template>
    <div :id="graphicId" class="total-graphic"></div>
</template>

<script>
import Chartist from 'chartist';
import ChannelMixin from '@/mixins/channels';
import legend from 'chartist-plugin-legend'; // eslint-disable-line
import broadcastResponseKeysMixin from '@/mixins/broadcastResponseKeys';
import ctBarLabelsMixin from '@/mixins/ctBarLabels';
import EventBus from '@/event-bus';

const qs = require('qs');
const _ = require('lodash');

window.Chartist = Chartist;

require('@/assets/js/ctBarLabels.js');

export default {
  props: {
    graphicId: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    responseKeys: {
      type: Object,
      required: true,
    },
    labels: {
      type: Array,
      required: false,
    },
    searchOnCreate: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: '60vh',
    },
  },
  mixins: [
    ChannelMixin,
    ctBarLabelsMixin,
    broadcastResponseKeysMixin,
  ],
  data() {
    return {
      series: [],
      labelsPosition: [],
    };
  },
  created() {
    EventBus.$on(`${this.graphicId}Reload`, () => {
      this.searchData();
    });
    EventBus.$on(`${this.graphicId}Rebuild`, () => {
      this.buildGraphic();
    });
    if (this.searchOnCreate) {
      this.searchData();
    }
  },
  destroyed() {
    EventBus.$off(`${this.graphicId}Reload`);
    EventBus.$off(`${this.graphicId}Rebuild`);
  },
  computed: {
    hasSeries() {
      return this.series.every(item => item.length);
    },
  },
  methods: {
    searchData() {
      /* eslint-disable */
      this.axios.get(`${this.url}?${qs.stringify(this.filters)}`).then((response) => {
        this.labelsPosition = [];
        let grouped = _.mapValues(_.groupBy(response.data, 'channel_id'),
                          clist => clist.map(channel => _.omit(channel, 'channel_id')));
        let reacheds = [];
        let totals = [];
        Object.keys(grouped).forEach((key) => {
          this.labelsPosition.push(key === 6 ? 'Call - Individual' : key === 5 ? 'Call - Discador' : this.showNameChannel(key));
          let reached = grouped[key].filter(item => item.status_type === 'reached');
          let not_reached = grouped[key].filter(item => item.status_type === 'not_reached');
          reacheds.push(parseInt(reached[0] ? reached[0].total : 0));
          totals.push(parseInt(not_reached[0] ? not_reached[0].total : 0) + parseInt(reached[0] ? reached[0].total : 0));
        });
        if (totals.length > 0) {
          this.series = [
            totals,
            reacheds,
          ];

        } else {
          this.labelsPosition = [
            'Email',
            'Sms',
            'Ivr',
            'Bot',
            'Call -Discador',
            'Call - Individual',
          ];
          this.series = [
            [
              0,
              0,
              0,
              0,
              0,
              0,
            ],
            [
              0,
              0,
              0,
              0,
              0,
              0,
            ],
          ];
        }

        this.buildGraphic();
      }).catch((error) => {
        console.log(error);
      });
      /* estlint-enable */
    },
    buildGraphic() {
      const maxValue = this.graphicMaxValue(this.series[0]);

      new Chartist.Bar(`#${this.graphicId}`, { // eslint-disable-line
        labels: this.labelsPosition || this.labels,
        series: this.series,
      }, {
        height: this.height,
        seriesBarDistance: 60,
        chartPadding: {
          bottom: 10,
          left: 30,
          right: 30,
        },
        plugins: [
          Chartist.plugins.ctBarLabels(),
          Chartist.plugins.legend({
            legendNames: [
              'Enviados',
              'Contactados',
            ],
          }),
        ],
        axisY: {
          type: Chartist.FixedScaleAxis,
          high: maxValue + this.graphicScale(maxValue),
          ticks: this.graphicTicks(maxValue),
          offset: 0,
        },
      });
    },
    isEmpty(value) {
      return value.length;
    },
  },
  watch: {
    series(newVal) {
      EventBus.$emit(`${this.graphicId}Series`, newVal);
    },
    filters: {
      deep: true,
      handler() { // eslint-disable-line
        this.searchData();
      },
    },
  },
};
</script>

<style scoped>
.total-graphic {
  min-height: 60vh;
}
</style>



// WEBPACK FOOTER //
// src/components/global/TotalGraphic.vue